var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RadioGroup',{attrs:{"value":_vm.selectedId,"vertical":""},on:{"on-change":_vm.onChange}},_vm._l((_vm.types),function(type){return _c('Radio',{key:type.id,attrs:{"label":type.id}},[_vm._v(" "+_vm._s(type.name)+" ("+_vm._s(_vm._f("price")(type.price,type.currency))+") ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }